import { ReactNode, useMemo } from 'react';
import { useBaseOwner } from './owner';

export const useFeatures = (): string[] => {
  const baseOwner = useBaseOwner();
  return useMemo(() => {
    const features = (baseOwner as { features?: unknown } | undefined)
      ?.features;
    return Array.isArray(features) ? (features as string[]) : [];
  }, [baseOwner]);
};

export const useFeature = (slug: string): boolean => {
  const features = useFeatures();
  return useMemo(() => features.includes(slug), [features, slug]);
};

export interface RequireFeatureProps {
  slug: string;
  children: ReactNode;
  fallback?: ReactNode;
}

export const RequireFeature = ({
  slug,
  children,
  fallback = null
}: RequireFeatureProps) => {
  const enabled = useFeature(slug);
  return <>{enabled ? children : fallback}</>;
};
